import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";
import Logo from "./Logo";
import { LayoutDashboard, FileText, FileSignature, LibraryBig, FileCode2, Settings as SettingsIcon, LogOut, GraduationCap, Megaphone, Calendar, Truck } from "lucide-react";

const nav = [
  { to: "/dashboard", label: "Painel", icon: LayoutDashboard, testid: "nav-dashboard" },
  { to: "/proposals", label: "Propostas", icon: FileText, testid: "nav-proposals" },
  { to: "/contracts", label: "Contratos", icon: FileSignature, testid: "nav-contracts" },
  { to: "/trainings", label: "Treinamentos", icon: GraduationCap, testid: "nav-trainings" },
  { to: "/events", label: "Eventos", icon: Calendar, testid: "nav-events" },
  { to: "/vendors", label: "Fornecedores", icon: Truck, testid: "nav-vendors" },
  { to: "/prospecting", label: "Prospecção", icon: Megaphone, testid: "nav-prospecting" },
  { to: "/items", label: "Biblioteca", icon: LibraryBig, testid: "nav-items" },
  { to: "/templates", label: "Modelos", icon: FileCode2, testid: "nav-templates" },
  { to: "/settings", label: "Configurações", icon: SettingsIcon, testid: "nav-settings" },
];

export default function AppLayout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  if (!user) {
    navigate("/", { replace: true });
    return null;
  }
  return (
    <div className="min-h-screen flex">
      <aside className="w-64 shrink-0 border-r border-border bg-white flex flex-col">
        <Link to="/dashboard" className="flex items-center gap-3 p-6 border-b border-border" data-testid="brand-link">
          <Logo size="md" />
        </Link>
        <nav className="flex-1 py-4">
          {nav.map(({ to, label, icon: Icon, testid }) => (
            <NavLink
              key={to}
              to={to}
              data-testid={testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-6 py-3 text-sm transition-colors border-l-2 ${
                  isActive
                    ? "border-[#C07C88] bg-[#FDF9EE]/40 text-[#1A1A1A] font-medium"
                    : "border-transparent text-muted-foreground hover:text-[#1A1A1A] hover:bg-[#F3F4F6]"
                }`
              }
            >
              <Icon size={16} strokeWidth={1.5} />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-border">
          <div className="flex items-center gap-3">
            {user.picture ? (
              <img src={user.picture} alt="" className="w-9 h-9 rounded-full object-cover" />
            ) : (
              <div className="w-9 h-9 rounded-full bg-[#D4AF37] text-white flex items-center justify-center text-sm font-semibold">
                {(user.name || user.email || "L")[0]?.toUpperCase()}
              </div>
            )}
            <div className="min-w-0 flex-1">
              <p className="text-xs font-medium truncate">{user.name || user.email}</p>
              <p className="text-[10px] text-muted-foreground truncate">{user.email}</p>
            </div>
            <button data-testid="logout-btn" onClick={logout} className="p-1.5 rounded hover:bg-[#F3F4F6] text-muted-foreground" title="Sair">
              <LogOut size={15} strokeWidth={1.5} />
            </button>
          </div>
        </div>
      </aside>
      <main className="flex-1 min-w-0 bg-[#FAFAFA]">{children}</main>
    </div>
  );
}
